<div class="ui-g">

    <div class="el_height ui-lg-10 ui-md-8 ui-sm-12">
        <p-chips [(ngModel)]="totaling" allowDuplicate=false (onRemove)="onRemove()"
            (onChipClick)="onChipClick($event)">
            <ng-template let-item pTemplate="item">
                <div pTooltip="{{item.Descriptions}}" [escape]=false>
                    <span>{{item.Names}}</span>
                </div>
            </ng-template>
        </p-chips>
    </div>
    <div class="ui-g-2 ui-lg-2 ui-md-4 ui-sm-12">
        <button type="button" (click)="pickNewAccountTotaling()" pButton icon="ui-icon-touch-app" label="Pick" style="width: 100%;"></button>
    </div>

    <p-dialog [modal]="true" [draggable]="false" [closable]="true" *ngIf="displayAccountTotaling" header="Pick account totaling" [closable]="true" [(visible)]="displayAccountTotaling" position="top" appendTo="body" [style]="{width: '100%', height: '100%', left: '0px', top: '0px'}" class="ui-fluid clear-ui">
        <p-tabView [activeIndex]="index" (onChange)="handleChange($event)">
        <p-tabPanel header="Totaling list">
                <div class="ui-g">
                    <div class="ui-g-6 ui-md-6">
                        <p-tabView>
                            <p-tabPanel leftIcon="ui-icon-filter-1" tooltip="Report accounts">
                                <ng-template pTemplate="content">
                                    <app-tree-accounts #accountsIncludedTree [reportId]="reportId" [included]="true"
                                        [filter]="this.filter">
                                    </app-tree-accounts>
                                </ng-template>
                            </p-tabPanel>
                            <p-tabPanel leftIcon="ui-icon-filter-2" tooltip="Report line accounts">
                                <ng-template pTemplate="content">
                                    <app-tree-accounts #accountsLineTree [reportId]="reportId" [lineId]="lineId"
                                        [filter]="this.filter">
                                    </app-tree-accounts>
                                </ng-template>
                            </p-tabPanel>
                            <p-tabPanel leftIcon="ui-icon-filter-3" tooltip="Excluded accounts for this line" [selected]="true">
                                <ng-template pTemplate="content">
                                    <app-tree-accounts #accountsExcludedTree [selectedLines]="this.accountsTotaling" [reportId]="reportId" [lineId]="lineId" [excluded]="true"
                                        selectionMode="multiple" [(selected)]="selectedAccountTotalingList" (unselectedNode)="removeUnselectedNode($event)"
                                        [filter]="this.filter" (onSearchEnter)="pickAllFilteredAccounts($event)">
                                    </app-tree-accounts>
                                </ng-template>
                            </p-tabPanel>
                            <p-tabPanel leftIcon="ui-icon-filter-4" tooltip="All accounts">
                                <ng-template pTemplate="content">
                                    <app-tree-accounts #accountsAllTree [reportId]="reportId" [all]="true"
                                        [filter]="this.filter">
                                    </app-tree-accounts>
                                </ng-template>
                            </p-tabPanel>
                        </p-tabView>
                        <div class="ui-g-12">
                            <button pButton type="button" label="Select" class="pull-right" iconPos="right" icon="ui-icon-arrow-forward" (click)="pick()"></button>
                        </div>
                    </div>
                    <div class="ui-g-6 ui-md-6" style="min-height: 520px;">
                        <p-treeTable #accountsTotalingTree *ngIf="displayAccountTotaling" [scrollable]="true" scrollHeight="400px" [rows]="12"
                            [virtualScroll]="true" [virtualRowHeight]="56" class="your-table"
                            [value]="accountsTotaling" [columns]="tableColumns" dataKey="id" [contextMenu]="cm"
                            contextMenuSelectionMode="joint" selectionMode="single" [(selection)]="this.selected">
                            <ng-template pTemplate="caption">
                                <input type="text" pInputText placeholder="Search..." (input)="accountsTotalingTree.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                            </ng-template>
                            <ng-template pTemplate="colgroup" let-columns>
                                <colgroup>
                                    <col *ngFor="let col of tableColumns" [style.width]="col.width">
                                </colgroup>
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let col of tableColumns">
                                        Selected accounts
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                                <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
                                    <td *ngFor="let col of tableColumns; let i = index">
                                        <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0">
                                        </p-treeTableToggler>
                                        {{rowData[col.field]}}
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="tableColumns.length">No data found.</td>
                                </tr>
                            </ng-template>
                        </p-treeTable>
                        <div class="ui-g-12">
                            <button pButton type="button" label="Remove" class="pull-left" iconPos="left" icon="ui-icon-arrow-back" (click)="unpick()"></button>
                        </div>
                    </div>
                    <p-contextMenu #cm [model]="items" appendTo="body"></p-contextMenu>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Totaling range">
                <ng-template pTemplate="content" class="ui-g">
                    <div class="ui-g-12 ui-md-6">
                        <h4>From Account...</h4>
                        <app-tree-accounts #accountsExcludedTreeRangeLeft [selectedLines]="this.accountsTotaling" [lineId]="lineId" [reportId]="reportId" [excluded]="true"
                        selectionMode="single" [(selected)]="this.selectedAccountTotalingRange1"
                        [filter]="this.filter">
                        </app-tree-accounts>
                    </div>
                    <div class="ui-g-12 ui-md-6">
                        <h4>...to Account</h4>
                        <app-tree-accounts #accountsExcludedTreeRangeRight [selectedLines]="this.selectedAccountTotalingRange1" [lineId]="lineId" [reportId]="reportId" [range]="true"
                        selectionMode="single" [(selected)]="selectedAccountTotalingRange2" [removeLoader]="true"
                        [filter]="this.filter">
                        </app-tree-accounts>
                    </div>
                </ng-template>
            </p-tabPanel>
        </p-tabView>

        <div class="ui-g-12">
            <button type="button" label="OK" pButton icon="ui-icon-check" (click)="okClickAccountTotaling()" style="margin-right: 0.5em"></button>
            <button type="button" label="Cancel" pButton icon="ui-icon-cancel" (click)="displayAccountTotaling = false"></button>
        </div>
    </p-dialog>
